import { GetterTree } from 'vuex'
import { RootState } from '../types'
import { SignInState } from './types'

export const getters: GetterTree<SignInState, RootState> = {}
